import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Container, Stack, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Navigation } from "swiper/modules";
import axios from "axios";
import { api } from "methods/api";
import { imgPath } from "methods/img";
import Spinner from "pages/SpinnerPage/Spinner";
import FixedSection from "Components/FixedSection";
import RenderRte from "Components/RenderRte";
import { ShoppingCardType } from "types/Shopping";
import { homeContext } from "pages/HomeContext";

function ShopDetails() {
  const { categoryId, id } = useParams();
  const { homeData } = useContext(homeContext);
  const [status, setStatus] = useState<"loading" | "done" | "error">("loading");
  const [shop, setShop] = useState<ShoppingCardType["shops"][number] | undefined>();

  useEffect(() => {
    setStatus("loading");
    axios
      .get<{ data: ShoppingCardType }>(api(`shop/${categoryId}`))
      .then(({ data }) => {
        const found = data.data.shops?.find((s) => String(s.id) === String(id));
        setShop(found);
        setStatus(found ? "done" : "error");
      })
      .catch((e) => {
        console.log("error", e);
        setStatus("error");
      });
  }, [categoryId, id]);

  if (status === "loading") return <Spinner />;
  if (status === "error" || !shop) {
    return (
      <Typography sx={{ textAlign: "center", py: 20 }}>Not found</Typography>
    );
  }

  const images = shop.images ?? [];

  return (
    <>
      <FixedSection title={homeData?.siteInformation?.explorer_title} />
      <Stack
        sx={{ py: 8, width: { md: "60%", xs: "90%" }, margin: "0 auto" }}
      >
        <Typography
          variant="h4"
          sx={{ textAlign: "center", py: 2, fontWeight: 600 }}
        >
          {shop.name}
        </Typography>

        {images.length > 0 && (
          <Box sx={{ py: 3 }}>
            <Swiper
              slidesPerView={1}
              spaceBetween={50}
              modules={[EffectFade, Autoplay, Navigation]}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              effect="fade"
              fadeEffect={{ crossFade: true }}
              loop
              navigation
              key={images.length}
            >
              {images.map((image, i) => (
                <SwiperSlide key={image.id ?? i}>
                  <img
                    src={imgPath(image.image)}
                    alt=""
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        )}

        <Box sx={{ my: 4 }}>
          <RenderRte rte={shop.description} />
        </Box>
        {shop.cost && (
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            {shop.cost}
          </Typography>
        )}
      </Stack>
    </>
  );
}

export default ShopDetails;